export default class Locale_ProjectPicker { 
	HeaderContent: string = "Switch sides";
	BodyHeaderText: string = "Project Picker";
	CloseButtonAreaLabel: string = "Close project picker panel";
	NoOwner: string = "No owner";
	Inactive: string = "INACTIVE";
	SuggestedProjects: string = "Suggested Projects";
	ProjectPickerSuggestionsAvailable: string = "Project Picker Suggestions available";	
	RecentlyUsedProjects: "Recently used projects";
}